// extracted by mini-css-extract-plugin
export default {"container":"CurrentUserPage_container__cPJTs","infos_container":"CurrentUserPage_infos_container__uO8N5","basic_info":"CurrentUserPage_basic_info__iuRXo"};